import _ from 'lodash';
import dynamic from 'next/dynamic';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { APP_IMG } from 'src/constants';

const CardFullNav = dynamic(import('src/components/cards/card-full-nav'));

const CardSubMenu = ({ menu, data }) => {
  if (_.isEmpty(data)) return null;
  const router = useRouter();

  const [articles, setArticles] = useState({
    key: null,
    data: data[0]?.data,
    link: data[0]?.link
  });

  return (
    <>
      <CardSubMenuStyle>
        <div className='row card-sub-menu'>
          <div className='col-3'>
            <ul>
              {!_.isEmpty(data) &&
                data.map((item, index) => (
                  <li
                    key={index}
                    aria-hidden='true'
                    onMouseOver={() => {
                      setArticles({
                        key: index,
                        data: item.data,
                        link: item.link
                      });
                    }}
                    onFocus={() => {}}
                  >
                    <a
                      href={item.link}
                      title={item.nameTh}
                      //! DATALAYER
                      onClick={() =>
                        sendDataLayerGlobal({
                          type: DATALAYER_TYPE.TRACK,
                          router: router?.pathname,
                          section: 'menubar',
                          data: {
                            title: item?.nameTh,
                            heading: `${menu?.nameTh}:${item?.nameTh}`
                          }
                        })
                      }
                    >
                      {item.nameTh}
                    </a>
                  </li>
                ))}
            </ul>
          </div>
          <div className='col-9 card-sub-menu-content'>
            {!_.isEmpty(articles?.data) ? (
              <>
                <div className='row'>
                  {articles.data.map((item, index) => (
                    <div key={index} className='col-4'>
                      <CardFullNav
                        key={index}
                        data={item}
                        //! DATALAYER
                        eventDatalayer={{
                          type: DATALAYER_TYPE.TRACK,
                          router: router?.pathname,
                          section: 'menubar',
                          data: {
                            heading: `${menu?.nameTh}`
                          }
                        }}
                      />
                    </div>
                  ))}
                </div>
                {/* <button className='btn-readmore'>
                    <a className='see-all' href={articles?.link} title='see all'>SEE ALL</a>
                  </button> */}
              </>
            ) : (
              <div className='empty'>
                <img
                  className='logo-img'
                  src={`${APP_IMG}/static/spring_logo_Black.png`}
                  loading='lazy'
                  alt='logo-mobile'
                  title='logo-mobile'
                  width='100px'
                  height='100px'
                />
              </div>
            )}
          </div>
        </div>
      </CardSubMenuStyle>
    </>
  );
};

const CardSubMenuStyle = styled.div`
  position: relative;
  .card-sub-menu {
    padding: 38px 15px;
    ul {
      overflow: hidden scroll;
      height: 178px;
      list-style: none;
      padding: 0;
      display: block;
      &::-webkit-scrollbar {
        width: 4px;
        background-color: rgb(0, 0, 0, 0.5);
        border-radius: 10px;
      }

      &::-webkit-scrollbar-track {
        background-color: rgb(247, 247, 247, 0.2);
        border-radius: 10px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: var(--primary-color);
      }

      li {
        padding: 5px;
        border-radius: 3px;
        margin-bottom: 16px;
        margin-left: 0;
        text-align: left;
        border: 2px;
        a {
          color: #fff !important;
          &:hover {
            padding-left: 16px;
            color: var(--primary-color) !important;
          }
        }
        i {
          float: right;
          color: transparent;
        }
        &:hover {
          color: #fff !important;
          border: unset;
          i {
            color: #fff !important;
          }
        }
      }
    }

    .card-sub-menu-content {
      position: relative;
      padding: 0 20px;
      .thumbnail a {
        picture {
          width: 100%;
          object-fit: cover;
          background-size: cover;
          background-position: center center;
        }
      }
      .empty {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        margin: auto;
        width: 100%;
        transform: translate(100px, 0px);
        display: flex;
        justify-items: center;
        align-items: center;
        .logo-img {
          width: 50%;
          height: 50%;
          opacity: 0.7;
        }
      }
    }
  }
`;
export default CardSubMenu;
